import React from "react";

export default function WareHouseMindSet() {
  return (
    <div
      className="m-4"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      No Data
    </div>
  );
}
